module.exports = __webpack_public_path__ + "media/images/lb/179-8d5a060f7a637ff59f089c439868ef46.svg";